import { loginRequest, loginSuccess } from 'redux/reducers/auth/reducer';
import axios from 'axios';
import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeEvery } from 'redux-saga/effects';
import { notificationContainer } from 'utils/notificationContainer';
import { api } from 'services';

import { IAdminAuthUserResponseData, ILoginRequestPayload } from './types';

// =============================================================:
function* loginRequestWorker(action: PayloadAction<ILoginRequestPayload>) {
	const { payload } = action;

	try {
		const response: IAdminAuthUserResponseData = yield call(api.auth.login, payload);

		yield put(loginSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			if (error?.response?.data?.errors?.totp) {
				const code: string = error?.response?.data?.errors?.totp[0];
				notificationContainer(code, 'info');
			} else {
				notificationContainer('The login or password is incorrect ', 'error');
			}
		}
	}
}

// =============================================================:
export function* authSaga() {
	yield takeEvery(loginRequest.type, loginRequestWorker);
}
